<template>
  <div class="goods-card-wrap"
       @click="toDetail">
    <MediaWrap :url="instance.picture"
               :width="180"
               :height="180"></MediaWrap>
    <div class="content-wrap">
      <a-row class="title-row">
        <a-col class="title-item-wrap"
               :span="20">
          <span class="title single-omit">{{ instance.patentName }}</span>
          <span class="type">【{{ instance.legalStatus }}】</span>
          <span class="type">【{{ instance.patentTypeStr }}】</span>
        </a-col>
        <a-col class="collection-wrap"
               :span="4">
          <span class="iconItem">
            <a-icon type="eye"
                    :style="{ color: '#364759' }" />
            <span>{{ instance.browseNum }}</span>
          </span>
          <span class="iconItem"
                @click="(e) => handleCollect(e, instance.id)">
            <a-icon type="star"
                    :theme="collectStatus"
                    :style="collectColor" />
            <span>{{ instance.collectNum }}</span>
          </span>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="12">
          <div class="list-item">
            <span>专利申请号：{{ instance.applyNum }}</span>
          </div>
        </a-col>
        <a-col :span="12">
          <div class="list-item">
            <span>公开(公告)号：{{ instance.publicNum }}</span>
          </div>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="12">
          <span>发布时间：</span>
          <span>{{ instance.publishTime }}</span>
        </a-col>
        <a-col :span="12">
          <span>交易类型：
            <a-tag class="w-f"
                   :color="operationTypeColor[instance.operationType]">
              {{ instance.operationTypeStr }}
            </a-tag>
          </span>
        </a-col>
      </a-row>
      <a-row>
        <a-col class="price-wrap"
               :span="8"
               :offset="16">
          <span class="price">价格： {{ instance.priceRange === -1 ? ' 面议' : `￥${instance.priceRange}` }}</span>
        </a-col>
      </a-row>
    </div>
  </div>
</template>

<script>
import { viewResultInfo } from '@/api/tradingInfos.js'

export default {
  props: {
    instance: Object,
  },
  data() {
    return {
      collectStatus: 'outlined',
      collectColor: { color: '#364759' },
      operationTypeColor: {
        0: '#89C997', // 转让
        1: '#6582FF', // 许可
        2: '#2279D2', // 质押
        3: '#FFC94D',
      },
    }
  },
  created() {
    this.handleCollectStatus()
  },
  methods: {
    async toDetail() {
      const { id } = this.instance
      this.$router.push({ name: 'detailDeal', query: { id } })
      await viewResultInfo(id)
    },
    handleCollect(e, id) {
      const {
        instance: { is_collect },
      } = this
      e.stopPropagation()
      this.$emit('collectStatus', id, is_collect)
    },
    // 收藏样式变化
    handleCollectStatus() {
      const {
        instance: { is_collect },
      } = this
      if (is_collect) {
        this.collectStatus = 'filled'
        this.collectColor = { color: '#57b9fe' }
        return
      }
    },
  },
}
</script>
